import { render, staticRenderFns } from "./LangFlagOptions.vue?vue&type=template&id=68dcfa3c&scoped=true&"
import script from "./LangFlagOptions.vue?vue&type=script&lang=js&"
export * from "./LangFlagOptions.vue?vue&type=script&lang=js&"
import style0 from "./LangFlagOptions.vue?vue&type=style&index=0&id=68dcfa3c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68dcfa3c",
  null
  
)

export default component.exports